import React from 'react';
import { Box, Typography } from '@mui/material';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import { brandColors } from '../../theme';
import CategoryGroup from './CategoryGroup';
import type { Idea } from '../../types/ideaBoard';

interface IdeaListProps {
  ideas: Idea[];
  isAdmin?: boolean;
}

const IdeaList: React.FC<IdeaListProps> = ({ ideas, isAdmin = false }) => {
  if (ideas.length === 0) {
    return (
      <Box
        sx={{
          textAlign: 'center',
          py: 8,
          color: brandColors.mediumGray,
        }}
      >
        <LightbulbOutlinedIcon sx={{ fontSize: 64, opacity: 0.4, mb: 2 }} />
        <Typography variant="h6" sx={{ mb: 1 }}>
          No ideas yet
        </Typography>
        <Typography variant="body2">
          Be the first to submit an idea and help shape the future of MarketCompass.
        </Typography>
      </Box>
    );
  }

  // Group ideas by category, sorted alphabetically by category name
  const grouped = ideas.reduce<Record<string, Idea[]>>((acc, idea) => {
    const cat = idea.category || 'Other';
    if (!acc[cat]) acc[cat] = [];
    acc[cat].push(idea);
    return acc;
  }, {});

  const sortedCategories = Object.keys(grouped).sort((a, b) => a.localeCompare(b));

  return (
    <Box>
      {sortedCategories.map((category) => (
        <CategoryGroup
          key={category}
          category={category}
          ideas={grouped[category]}
          isAdmin={isAdmin}
        />
      ))}
    </Box>
  );
};

export default IdeaList;
